/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var mirai = {
    // All pages
    'common': {
      init: function() {
		// Hide Sub Menu when clicking outside 

		$(document).click(function (e) {
			if (document.documentElement.clientWidth > 900) {
			    e.stopPropagation();
			    var container = $("#menu-shop, #menu-shop-1 ");

			    //check if the clicked area is dropDown or not
			    if (container.has(e.target).length === 0) {
			        $('#menu-shop li, #menu-shop-1 li, .sub-menu').removeClass('menu-active');
			    }
			}
		});

		$('#menu-shop > li, #menu-shop-1 > li').click(function() {
		    var $this = $(this),
		        $ul   = $('> ul', this);
		    
		    if (!$ul.hasClass('menu-active')) {

				// Add class to current list item 
				$this.addClass('menu-active');

		        // Slide down used for mobiles
				$ul.toggleClass('menu-active').slideDown();

		    } else {

		    	$this.removeClass('menu-active');

		    	$ul.removeClass('menu-active');

		    }
		});
		
		$('.mobile-trigger').click(function() {
			$(this).find('span').toggleClass('mobile-menu-active');
			$('body').toggleClass('mobile-menu-active');
		});

		$('.app-close-nav').click(function() {
			$('.mobile-trigger span').toggleClass('mobile-menu-active');
			$('body').toggleClass('mobile-menu-active');
		});

		$('.modal__close').click(function() {
			$('.modal').hide();
		});

		$('.tabgroup > div').hide();
		$('.tabgroup > div:first-of-type').show();
		$('.tabs a').click(function(e){
			e.preventDefault();
			var $this = $(this),
			tabgroup = '#'+$this.parents('.tabs').data('tabgroup'),
			others = $this.closest('li').siblings().children('a'),
			target = $this.attr('href');
			others.removeClass('active');
			$this.addClass('active');
			$(tabgroup).children('div').hide();
			$(target).show();
		});

		$('.testimonial-list__content ul').slick({
			dots: true,
			slidesToShow: 1,
			adaptiveHeight: true
		});
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'profile': {
    	init: function() {
			$('.tabgroup > div').hide();
			$('.tabgroup > div:first-of-type').show();
			$('.tabs a').click(function(e){
				e.preventDefault();
				var $this = $(this),
				tabgroup = '#'+$this.parents('.tabs').data('tabgroup'),
				others = $this.closest('li').siblings().children('a'),
				target = $this.attr('href');
				others.removeClass('active');
				$this.addClass('active');
				$(tabgroup).children('div').hide();
				$(target).show();
			});
    	}
    },
    'parent_faqs': {
    	init: function() {
		    $('.faq__questions__accordion > li:eq(0) a').addClass('active').next().slideDown();

		    $('.faq__questions__accordion a').click(function(j) {
		        var dropDown = $(this).closest('li').find('div');

		        $(this).closest('.faq__questions__accordion').find('div').not(dropDown).slideUp();

		        if ($(this).hasClass('active')) {
		            $(this).removeClass('active');
		        } else {
		            $(this).closest('.faq__questions__accordion').find('a.active').removeClass('active');
		            $(this).addClass('active');
		        }

		        dropDown.stop(false, true).slideToggle();

		        j.preventDefault();
		    });
    	}
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = mirai;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
